import { Button } from '@/components/ui/button'
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Calendar, ChevronDown } from 'lucide-react'

interface TimeRange {
  label: string
  value: string
  days: number
}

interface TimeRangeSelectorProps {
  selectedRange: TimeRange
  onRangeChange: (range: TimeRange) => void
  ranges: TimeRange[]
}

export function TimeRangeSelector({ selectedRange, onRangeChange, ranges }: TimeRangeSelectorProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="w-40">
          <Calendar className="mr-2 h-4 w-4" />
          {selectedRange.label}
          <ChevronDown className="ml-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {ranges.map((range) => (
          <DropdownMenuItem
            key={range.value}
            onClick={() => onRangeChange(range)}
            className={selectedRange.value === range.value ? 'bg-accent' : ''}
          >
            <div className="flex items-center justify-between w-full">
              <span>{range.label}</span>
              {range.days && (
                <span className="text-xs text-muted-foreground">{range.days}d</span>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
} 